/**
 * @voltxampere/ui — Varactor diode (Sprint 45-4, placeholder)
 *
 * PLACEHOLDER. Reverse-biased junction capacitance C(V_R) function
 * datasheet meta üzerinden Inspector'da görünür. Gerçek voltage-
 * dependent capacitance stamp (BSIM4-style C-V curve) Sprint 50+
 * engine extension #4 ile.
 *
 * Reference: Generic varactor — NXP 1SV101, Skyworks SMV1247-079LF,
 * MACOM MA46H120. Reverse-bias capacitance 0.5-100 pF (V_R = 0-30 V),
 * Q > 100 @ 50 MHz. VCO tank (frequency tuning), AFC, RF tuner,
 * PLL synthesizer.
 *
 *   Default mapping → diode schemaType:
 *     saturationCurrent = 1e-14
 *     ideality = 1
 *
 * Engine zero-diff invariant honored — canonical `diode` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const diodeVaractor = {
    id: "varactor",
    nameTr: "Varactor 1SV101 (variable cap, placeholder)",
    nameEn: "Varactor 1SV101 (variable cap, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "D",
    defaultValue: "VARACTOR",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 1e-14, ideality: 1 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=diode-varactor.js.map